import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import { dsClass } from '../../common/constants/dsClasses';

import './HeaderWithButton.scss';

export interface HeaderWithEditButtonProps {
  title: string;
  showButton: boolean;
  buttonText: string;
  onClick: () => void;
  disabled?: boolean;
}

export const HeaderWithEditButton = ({
  title,
  showButton,
  buttonText,
  onClick,
  disabled,
}: HeaderWithEditButtonProps) => {
  return (
    <div className="header-and-button">
      <h3 className={classNames(dsClass.H3_BOOK)}>{title}</h3>
      {showButton && (
        <CL.Button onClick={onClick} color="secondary" disabled={disabled}>
          {buttonText}
        </CL.Button>
      )}
    </div>
  );
};
